export default __webpack_public_path__ + "static/say-less-image-graph-1d2bcebc4493197f57b554ac5712cf61.jpg";